
<div class="cards-list row">
        <!-- <div class="nglist-item col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <a class="nglist-item-content cards-list-item-link" routerLink="/services/{{serviceId}}/settings">
                <h1 class="fas fa-cogs mb-3"></h1>
                <span class="nglist-item-content-title">Publish settings</span>
            </a>
        </div> -->
</div>